// Kaynak Takibi ortak sabitleri (hosgelsin).
export const API_BASE = 'https://api.glowytics.com/api/attribution';
// Marka: her zaman useAuth().selectedBrand. Hangi markaların sayfaya girebildiği App.js ve Sidebar.js'teki
// allowBrandIds / restrictedBrands listesinde; buraya marka eklemek gerekmez.
export const DETECTED_LABELS = {
  page_data: 'Sayfa verisi', datalayer: 'dataLayer', adapter: 'Adaptör', jsonld: 'JSON-LD', manual: 'Manuel', server: 'Sunucu', legacy: 'Eski',
};
export const detectedList = (v) => (v ? String(v).split('+').filter(Boolean) : []);

export const EVENT_LABELS = {
  page_view: 'Sayfa görüntüleme', view_item_list: 'Ürün listesi görüntüleme', select_item: 'Ürün seçimi', view_item: 'Ürün görüntüleme',
  add_to_cart: 'Sepete ekleme', remove_from_cart: 'Sepetten çıkarma', view_cart: 'Sepet görüntüleme', begin_checkout: 'Ödemeye başlama',
  add_shipping_info: 'Teslimat bilgisi', add_payment_info: 'Ödeme bilgisi', purchase: 'Satın alma', search: 'Arama',
  scroll_90: 'Sayfayı %90 kaydırma', user_engagement: 'Etkileşim',
};
export const EVENT_TONE = {
  purchase: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  begin_checkout: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  add_to_cart: 'bg-violet-50 text-violet-700 border-violet-200',
  view_item: 'bg-sky-50 text-sky-700 border-sky-200',
};
export const evLabel = (n) => EVENT_LABELS[n] || n;

export const CHANNELS = {
  paid_search: { label: 'Ücretli arama', color: '#4f46e5' }, paid_social: { label: 'Ücretli sosyal', color: '#db2777' },
  organic_search: { label: 'Organik arama', color: '#059669' }, organic_social: { label: 'Organik sosyal', color: '#0891b2' },
  ai: { label: 'Yapay zekâ', color: '#7c3aed' }, referral: { label: 'Yönlendirme', color: '#d97706' },
  email: { label: 'E-posta', color: '#ea580c' }, direct: { label: 'Doğrudan', color: '#6b7280' },
  internal: { label: 'Site içi', color: '#9ca3af' }, other: { label: 'Diğer', color: '#a1a1aa' },
};
export const chLabel = (c) => (c ? (CHANNELS[c]?.label || c) : '-');
export const chColor = (c) => CHANNELS[c || 'direct']?.color || '#a1a1aa';

export const CONSENT = {
  granted: { label: 'İzinli', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  denied: { label: 'İzinsiz', cls: 'bg-rose-50 text-rose-700 border-rose-200' },
  unknown: { label: 'Bilinmiyor', cls: 'bg-gray-100 text-gray-600 border-gray-200' },
};
export const ORIGIN = {
  browser: { label: 'Tarayıcı', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
  server: { label: 'Sunucu', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  both: { label: 'İkisi', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
};
export const nf = new Intl.NumberFormat('tr-TR');
export const money = (v, cur = 'TRY') => {
  try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: cur || 'TRY', maximumFractionDigits: 0 }).format(v || 0); }
  catch (e) { return `${nf.format(Math.round(v || 0))} ₺`; }
};
export const fmtTime = (s) => {
  if (!s) return '-';
  const d = new Date(s);
  return isNaN(d) ? '-' : d.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });
};
export const ymd = (d) => new Date(d.getTime() + 3 * 3600e3).toISOString().slice(0, 10);
export const daysAgo = (n) => ymd(new Date(Date.now() - n * 86400e3));
export const pathOf = (u) => { if (!u) return '-'; try { const x = new URL(u); return x.pathname + x.search; } catch (e) { return String(u); } };
